import React from "react"
import { cn } from "../../utils/cn"

export type BadgeVariant =
    | "neutral"
    | "primary"
    | "success"
    | "warning"
    | "orange"
    | "danger"

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
    variant?: BadgeVariant
}

const variantClasses: Record<BadgeVariant, string> = {
    neutral: "bg-elevated text-muted",
    primary: "bg-primary/15 text-primary",
    success: "bg-success-soft text-success-text",
    warning: "bg-warning-soft text-warning-text",
    // Laranja distinto do âmbar (warning); usado para "Expirando" (par perto de vencer).
    orange: "bg-orange-500/15 text-orange-600 dark:text-orange-400",
    danger: "bg-danger-soft text-danger-text",
}

/** Pílula de status tonal (par soft/text que responde a light/dark). */
const Badge: React.FC<BadgeProps> = ({
    variant = "neutral",
    className,
    children,
    ...props
}) => {
    return (
        <span
            className={cn(
                "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide",
                variantClasses[variant],
                className
            )}
            {...props}
        >
            {children}
        </span>
    )
}

export default Badge
